import { Injectable } from '@angular/core';
import { FloorTenantCompany, FloorTenantCompanyDto } from '../../models/provider-parking/floor-tenant-company.model';

@Injectable({
    providedIn: 'root',
})
export class MapperFloorTenantCompanyService {
    
    public mapFromDto(dto: FloorTenantCompanyDto): FloorTenantCompany {
        return {
            id: dto.Id || 0,
            name: dto.Name || '',
            parkingType: dto.ParkingType || '',
            lots: dto.LotCount || 0,
            serviceArea: dto.ServiceArea || '',
            image1: dto.Image1 || '',
            image2: dto.Image2 || '',
            image3: dto.Image3 || '',
            isOnline: dto.IsOnline ?? false
        };
    }

    public mapToDto(model: FloorTenantCompany): FloorTenantCompanyDto {
        return {
            Id: model.id,
            Name: model.name,
            ParkingType: model.parkingType,
            LotCount: model.lots,
            ServiceArea: model.serviceArea,
            Image1: model.image1,
            Image2: model.image2,
            Image3: model.image3,
            IsOnline: model.isOnline
        };
    }
}
